<template>
  <div :class="$style['page-header']">
    <img
      v-if="hasBackButton"
      :class="$style['back-button']"
      src="@assets/images/icons/arrow-left.svg"
      alt="back"
      @click="$emit('back')"
    />
    <slot></slot>
    <div v-if="tableNumber" :class="$style['table-number-container']">
      <p
        :class="$style['table-number']"
        v-color="colorFont"
        v-font-style="fontDetail"
        v-text="`#${tableNumber}`"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    colorFont: {
      type: String,
      default: '',
    },
    fontDetail: {
      type: Object,
      default: () => {},
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
    imageSource: {
      type: String,
      default: '',
    },
    tableNumber: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.page-header {
  height: 56px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .back-button {
    position: absolute;
    top: 16px;
    left: 16px;
  }

  .table-number-container {
    position: absolute;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    right: 16px;
    max-width: 60px;

    .table-number {
      font-size: 16px;
    }
  }
}
</style>
